import React from "react";
import { Box } from "@mui/material";

const Slider = ({ children }) => {
  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexFlow: "wrap",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Slider;
